import React from 'react';
import StepFooter from './StepFooter';
import { IMPORT_FIELDS, claimImportColumn } from '../../../domain/importDelimited';
import s from '../import.module.css';

const PREVIEW_ROWS = 5;


export default function MatchStep({
  headers, rows, mapping, hasHeader, onMappingChange, onBack, onCancel, onNext,
}) {
  const preview = hasHeader ? rows.slice(1, PREVIEW_ROWS + 1) : rows.slice(0, PREVIEW_ROWS);

  return (
    <>
      <div className={`${s.imCard} ${s.imWide}`}>
        <div className={s.imStep}>Step 3/4</div>
        <div className={s.imQ}>Match Data</div>
        <div className={s.imHint}>
          This is a preview of your data — you will see all of it in the next step. Each column
          below has been matched to a field automatically. Change any that are wrong: a column
          matched to the wrong field imports without complaint and looks like it worked.
        </div>
      </div>

      <div className={s.imWrap}>
        <table className={s.imT}>
          <thead>
            <tr>
              {headers.map((h, i) => {
                const matched = mapping[i] && mapping[i] !== 'skip';
                return (
                  <th key={i}>
                    <div className={s.headerCell}>{h || `Column ${i + 1}`}</div>
                    <select
                      className={s.imCtl}
                      value={mapping[i] || 'skip'}
                      onChange={(e) => onMappingChange(claimImportColumn(mapping, i, e.target.value))}
                    >
                      {IMPORT_FIELDS.map((f) => (
                        <option key={f.key} value={f.key}>{f.label}</option>
                      ))}
                    </select>
                    <div>
                      <span className={`${s.imBadge} ${matched ? s.badgeMatched : s.badgeSkipped}`}>
                        {matched ? 'Matched' : 'Not imported'}
                      </span>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {preview.map((r, n) => (
              <tr key={n}>
                {headers.map((_, i) => <td key={i}>{r[i] ?? ''}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={`${s.imCard} ${s.imWide}`}>
        <StepFooter bare onBack={onBack} onCancel={onCancel} onNext={onNext} />
      </div>
    </>
  );
}
